import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { delay, tap } from 'rxjs/operators';

import { AuthUserModel, UserModel } from '../../models';

@Injectable()
export class EstimatorUserService {
	public userSubject: BehaviorSubject<UserModel> = new BehaviorSubject<UserModel>(null);
	public userDataStream: Observable<UserModel> = this.userSubject.asObservable().pipe(
		delay(0),
		tap((user: UserModel | null) => {
			this.hasUser = !!user;
		})
	);

	public hasUser: boolean = false;

	constructor() {}

	public setUser(user: UserModel): void {
		this.userSubject.next(user);
	}

	public setUserFromAuth(authUser: AuthUserModel | null) {
		if (!authUser) {
			this.userSubject.next(null);
			return;
		}

		const current = this.userSubject.getValue();
		const next = new UserModel(authUser);

		if (!current || JSON.stringify(current) !== JSON.stringify(next)) {
			this.userSubject.next(next);
		}
	}
}
